<style>
#badges {
    padding-top: 20px;
    padding-bottom: 0px;
}

.blank-badge {
    width: 30px;
    height: 30px;
    margin: 4px;
    border-radius: 50%;
    border: 1px dashed rgb(155, 155, 155);
    display: inline-block;
    margin-right: 8px;
    cursor: pointer;
}

.badge {
    margin-right: 8px;
    width: 40px;
    cursor: pointer;
    user-select: none;
    outline: none;
}

.tooltip {
    position: relative;
    display: inline-block;
}
</style>

<script>
export let item_count;
export let comment_count;
export let like_count;

let badges = []

$: blanksArray = genBlanksArray(
    calcNumOfBadges(item_count) +
    calcNumOfBadges(comment_count) +
    calcNumOfBadges(like_count)
)

function calcNumOfBadges(n) {
    if(n > 99) {
        return 3;
    }
    if(n > 9) {
        return 2;
    }
    if(n > 0) {
        return 1;
    }

    return 0;
}

function genBlanksArray(size) {
    if(size == 9) {
        return []
    }

    let res = []
    for(var i = size; i < 10; i++) {
        res.push(true)
    }
    return res;
}
</script>

<div id="badges">
    {#if item_count > 0}
        <div class="tooltip" title="Starter Badge (1 Item Contributed)" on:click={
            function() {
                alert("Starter Badge (1 Item Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_item_1.png" alt="Badge Image">
        </div>
    {/if}
    {#if comment_count > 0}
        <div class="tooltip" title="Non-Bystander Badge (1 Comment Contributed)" on:click={
            function() {
                alert("Non-Bystander Badge (1 Comment Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_comment_1.png" alt="Badge Image">
        </div>
    {/if}
    {#if like_count > 0}
        <div class="tooltip" title="Likie Badge (1 Item Likes Contributed)" on:click={
            function() {
                alert("Likie Badge (1 Item Likes Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_prop_1.png" alt="Badge Image">
        </div>
    {/if}

    {#if item_count > 9}
        <div class="tooltip" title="Architect Badge (Over 10 Items Contributed)" on:click={
            function() {
                alert("Architect Badge (Over 10 Items Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_item_2.png" alt="Badge Image">
        </div>
    {/if}
    {#if comment_count > 9}
        <div class="tooltip" title="Snapbacker Badge (Over 10 Comments Contributed)" on:click={
            function() {
                alert("Snapbacker Badge (Over 10 Comments Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_comment_2.png" alt="Badge Image">
        </div>
    {/if}
    {#if like_count > 9}
        <div class="tooltip" title="Likester Badge (Over 100 Item Likes Contributed)" on:click= {
            function() {
                alert("Likester Badge (Over 100 Item Likes Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_prop_2.png" alt="Badge Image">
        </div>
    {/if}

    {#if item_count > 99}
        <div class="tooltip" title="Statesman Badge (Over 100 Items Contributed)" on:click={
            function() {
                alert("Statesman Badge (Over 100 Items Contributed")
            }
        }>
            <img class="badge" src="/badges/badge_item_3.png" alt="Badge Image">
        </div>
    {/if}
    {#if comment_count > 99}
        <div class="tooltip" title="Big Mouth Badge (Over 100 Comments Contributed)" on:click={
            function() {
                alert("Big Mouth Badge (Over 100 Comments Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_comment_3.png" alt="Badge Image">
        </div>
    {/if}
    {#if like_count > 99}
        <div class="tooltip" title="Likezilla Badge (Over 1000 Item Likes Contributed)" on:click= {
            function() {
                alert("Likezilla Badge (Over 1000 Item Likes Contributed)")
            }
        }>
            <img class="badge" src="/badges/badge_prop_3.png" alt="Badge Image">
        </div>
    {/if}

    {#if item_count > 99 && comment_count > 99 && like_count > 99}
        <div class="tooltip" title="Urban Master Badge (Earned all other Badges)" on:click={
            function() {
                alert("Urban Master Badge (Earned all other Badges)")
            }
        }>
            <img class="badge" src="/badges/badge_all.png" alt="Badge Image">
        </div>
    {/if}

    {#each blanksArray as b}
        <div class="tooltip" title="User has not earned this Badge yet" on:click={
            function() {
                alert("User has not earned this Badge yet")
            }
        }>
            <div class="blank-badge"></div>
        </div>
    {/each}
</div>